<template>
 <!--
    ********************************************************
    ****   FORMATO NUMERO 15 CARRUSEL CON  TEXTO        ****
    ****                                                ****
    ********************************************************
  -->
<div> 
    <div v-for="(contenido,index) in contenidos" :key="index" class="row">
      
                  <div class="col-12 col-sm-12 col-xl-5 col-lg-5 col-md-5" >
                    <div class="contenedor-carousel">
                      <carousel :autoplay="autoPlay" :responsive="itemsCarrusel(contenido.CarruselDeMicrositios)">
                         <div v-for="(archivos,index2) in contenido.ArchivosDeContenidoMicrositios" :key="index2" v-if="archivos.EsImagen">
                         <router-link to="#">
                           <div class="contenedor-imagenes">
                           <img class="imagen-carrusel" v-bind:src="archivos.RutaDelArchivo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos) " alt="imagen">
                           
                           </div>
                           </router-link> 
                        </div> 
                      </carousel>
                    </div>
                  </div>
                   <div class="col-12 col-sm-12 col-xl-7 col-lg-7 col-md-7 contenedor-texto" >
                    <div v-for="(texto,index3) in contenido.ArchivosDeContenidoMicrositios" :key="index3" >
                      <div v-if="texto.EsImagen == false"><h6 class="titulo-carrusel" >{{texto.Titulo}}</h6>
                      <p class="texto-carrusel">{{texto.TextoDescripcion}}</p></div>
                    </div>
                  </div>  
                  <hr>
    </div>
</div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
  data: function(){
     return{
      autoPlay: false,
      SERVIDOR_LOCAL:'\\\\themisfs',
       enumeraciones_sicpo
     }
       
    },
    props:{
        contenidos: Array
    },
    components:{
        carousel
    },
     methods:{
        itemsCarrusel:function(elemento){
          console.log("carrusel texto itemsCarrusel");               
                this.autoPlay = elemento.AutoPlay;
                var opciones ={0:{items:elemento.Elementos00,nav:false},600:{items:elemento.Elementos600,nav:false},800:{items:elemento.Elementos800,nav:false},1200:{items:elemento.Elementos1200,nav:false}}
                return opciones;
       }
    }
}
</script>

<style scoped>
.imagen-carrusel{
   height: 30em;
  border-radius:2em ;
}
.contenedor-imagenes{
  /* background-color:blue; */
  margin:10px ;
}

.titulo-carrusel{
  font-family: 'AntenaBeta';
    font-size: 1.4em;
    
}
.texto-carrusel{
   font-family: 'Myriad';
    font-size: 1.2em;
    text-align: justify;
}

.contenedor-texto{
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/CarruselYTexto.vue